// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"692":"styles/app","889":"styles/admin"}[chunkId] + ".css";
};